import { ArrowRight, Clock } from "lucide-react";
import { Layout } from "../components/Layout";
import { guides, ratgeberHub } from "../data/guides";

/** Pillar/hub page (route "/ratgeber") linking out to every guide. */
export function RatgeberHub(): JSX.Element {
  return (
    <Layout>
      <section className="border-b border-surface-variant/50 bg-surface-container-low py-16 sm:py-20 lg:py-24">
        <div className="container-welope">
          <nav aria-label="Brotkrumen" className="mb-6">
            <ol className="flex items-center gap-2 font-body text-label-sm text-on-surface-variant">
              <li>
                <a href="/" className="transition-colors hover:text-primary">
                  Start
                </a>
              </li>
              <li aria-hidden>›</li>
              <li className="text-primary">Ratgeber</li>
            </ol>
          </nav>
          <div className="max-w-2xl">
            <p className="section-eyebrow">Wissen für Halter</p>
            <h1 className="mt-3 font-headline text-[40px] font-extrabold leading-[1.05] tracking-[-0.02em] text-primary sm:text-[52px]">
              {ratgeberHub.title}
            </h1>
            <p className="mt-5 font-body text-body-lg leading-[1.55] text-on-surface-variant">
              {ratgeberHub.intro}
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-20 lg:py-24">
        <div className="container-welope">
          <ul className="grid grid-cols-1 gap-lg sm:grid-cols-2 lg:grid-cols-3">
            {guides.map((guide) => (
              <li key={guide.slug}>
                <a
                  href={`/ratgeber/${guide.slug}`}
                  className="card-bloom group flex h-full flex-col p-md transition-transform hover:-translate-y-1"
                >
                  <span className="section-eyebrow">{guide.category}</span>
                  <h2 className="mt-3 font-headline text-headline-md leading-tight text-on-surface">
                    {guide.title}
                  </h2>
                  <p className="mt-3 flex-1 font-body text-body-md leading-[1.55] text-on-surface-variant">
                    {guide.description}
                  </p>
                  <span className="mt-5 flex items-center justify-between font-body text-label-sm text-on-surface-variant">
                    <span className="flex items-center gap-1.5">
                      <Clock className="h-3.5 w-3.5" aria-hidden="true" />
                      {guide.readingMinutes} Min.
                    </span>
                    <span className="flex items-center gap-1 font-medium text-primary">
                      Lesen
                      <ArrowRight
                        className="h-4 w-4 transition-transform group-hover:translate-x-0.5"
                        aria-hidden="true"
                      />
                    </span>
                  </span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </Layout>
  );
}
